import Accordion from 'accordion-js';

const ACCORDION_INITED_ATTR = 'data-cdv-accordion-inited';
const accordionInstances = new WeakMap();

/**
 * Ouvre un panneau par id (#ac-villes, #ac-regions, …) via l'instance accordion-js.
 * @param {Element} container - .cdv-accordion
 * @param {string} panelId
 * @returns {boolean}
 */
export function openAccordionPanelById(container, panelId) {
  if (!container || !panelId) {
    return false;
  }

  const instance = accordionInstances.get(container);
  const items = Array.from(container.querySelectorAll('.ac'));
  const target = container.querySelector(`#${CSS.escape(panelId)}`);
  const index = target ? items.indexOf(target) : -1;

  if (index < 0 || !instance) {
    return false;
  }

  items.forEach((_, i) => {
    instance.close(i);
  });
  instance.open(index);

  return true;
}

if (typeof window !== 'undefined') {
  window.cdvOpenAccordionPanelById = openAccordionPanelById;
}

/**
 * Initialise un seul conteneur accordion (.cdv-accordion).
 * Utilisé notamment pour la popup filtre (initialisation à l'ouverture du modal).
 * @param {Element} elem - Élément conteneur avec la classe .cdv-accordion
 * @returns {boolean} true si initialisé, false si déjà initialisé ou élément invalide
 */
export function initAccordionContainer(elem) {
  if (!elem || elem.getAttribute(ACCORDION_INITED_ATTR) === 'true') return false;
  const items = elem.querySelectorAll('.ac');
  if (items.length === 0) return false;

  const accordion = new Accordion([elem], {
    duration: 400,
    activeClass: 'cdv-is-active',
    showMultiple: true
  });

  items.forEach((item, i) => {
    if (item.classList.contains('active')) {
      accordion[0].open(i);
    }
  });

  const parent = elem.closest('.section-body');
  if (parent) {
    const toggleButton = parent.querySelector('.accordion__toggle');
    if (toggleButton) {
      toggleButton.addEventListener('change', () => {
        if (toggleButton.checked) {
          items.forEach((item, i) => {
            accordion[0].open(i);
          });
        } else {
          items.forEach((item, i) => {
            accordion[0].close(i);
          });
        }
      });
    }
  }

  accordionInstances.set(elem, accordion[0]);
  elem.setAttribute(ACCORDION_INITED_ATTR, 'true');
  return true;
}

export function initAccordion() {
  document.querySelectorAll('.cdv-accordion').forEach(function(elem) {
    // Ne pas initialiser les accordéons dans un modal (ex. popup-filtre) :
    // sur single-landing c'est souvent le seul .cdv-accordion (pas de FAQ), donc
    // il était init alors que le modal était caché → sous Windows les accordéons
    // ne s'ouvraient pas. On les init à l'ouverture du modal (voir popup-filtre.js).
    if (elem.closest('.modal-offcanvas')) return;
    initAccordionContainer(elem);
  });

  document.querySelectorAll('.footer-accordion').forEach(function(elem) {
    new Accordion([elem], {
      duration: 400,
      activeClass: 'cdv-is-active',
      elementClass: 'footer-ac',
      triggerClass: 'footer-trigger',
      panelClass: 'footer-slide'
    });
  });
}
